import type { DependencyStatus, Module, ModuleDependency } from '@/schemas/commons';

export type PlatformHealth = {
	status: DependencyStatus;
	moduleCount: number;
	checkedDeps: number;
	issueCount: number;
};

const STATUS_RANK: Record<DependencyStatus, number> = {
	up: 0,
	disabled: 0,
	degraded: 1,
	down: 2,
};

const worst = (a: DependencyStatus, b: DependencyStatus): DependencyStatus =>
	STATUS_RANK[a] >= STATUS_RANK[b] ? a : b;

const isIssue = (dep: ModuleDependency): boolean =>
	dep.status === 'down' || (dep.required && dep.status === 'degraded');

export const aggregatePlatformHealth = (modules: Module[]): PlatformHealth => {
	const allDeps = modules.flatMap((mod) => (mod.health ? mod.health.dependencies : []));
	const status = modules.reduce<DependencyStatus>(
		(acc, mod) => (mod.health ? worst(acc, mod.health.status) : acc),
		'up',
	);
	const activeDeps = allDeps.filter((dep) => dep.status !== 'disabled');
	const checkedDeps = activeDeps.length;
	const issueCount = activeDeps.filter(isIssue).length;

	return {
		status,
		moduleCount: modules.length,
		checkedDeps,
		issueCount,
	};
};
